import { render, staticRenderFns } from "./PostTitle.vue?vue&type=template&id=f2f8bb38&scoped=true"
import script from "./PostTitle.vue?vue&type=script&lang=js"
export * from "./PostTitle.vue?vue&type=script&lang=js"
import style0 from "./PostTitle.vue?vue&type=style&index=0&id=f2f8bb38&prod&scoped=true&lang=css"
import style1 from "./PostTitle.vue?vue&type=style&index=1&id=f2f8bb38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f8bb38",
  null
  
)

export default component.exports